// @ts-nocheck
import { UserBlockchainBalance } from '__generated__/graphql'

export const getFormattedBalances = (balance: UserBlockchainBalance) => ({
  formattedBalance: Number(balance.tokenBalance.toFixed(2)),
  formattedTreasury: Number(balance.tokenDeposited.toFixed(2)),
  formattedNative: Number(balance.nativeBalance.toFixed(4))
})
